"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("HubStyleTokens/colors");

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var DEFAULT_ICON_SIZE = 24;

var PieSyncConnectorIcon = function PieSyncConnectorIcon(_ref) {
  var className = _ref.className,
      Link = _ref.linkComponent,
      linkProps = _ref.linkProps,
      size = _ref.size;
  var getLinkProps = (0, _react.useCallback)(function () {
    // TODO add piesync link
    return linkProps || {
      href: '#'
    };
  }, [linkProps]);
  return _react.default.createElement(_UITooltip.default, {
    title: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "ecosystemMarketplaceCore.pieSyncConnector.iconTooltip_jsx",
      elements: {
        Link: Link
      },
      options: (0, _extends2.default)({}, getLinkProps(), {
        use: 'on-dark'
      })
    }),
    placement: "right"
  }, _react.default.createElement(_UIIcon.default, {
    className: className,
    color: _colors.OBSIDIAN,
    name: "piesync",
    size: size
  }));
};

PieSyncConnectorIcon.propTypes = {
  className: _propTypes.default.string,
  linkComponent: _propTypes.default.oneOfType([_propTypes.default.elementType, _propTypes.default.func]),
  linkProps: _propTypes.default.object,
  size: _UIIcon.default.propTypes.size
};
PieSyncConnectorIcon.defaultProps = {
  linkComponent: _UILink.default,
  size: DEFAULT_ICON_SIZE
};
var _default = PieSyncConnectorIcon;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/common/PieSynConnectorIcon.js
// module id = 375
// module chunks = 209 210 211 212